module.exports = __webpack_public_path__ + "static/media/options.33d1f842.svg";